import * as Yup from "yup";

export const appointmentRecurrenceEndingField = (t) => Yup.string()
  .nullable()
  .when("repeats", {
    is: "Yes",
    then: () => Yup.string().trim().required(t("Ending date is required for repeating appointments")),
  });
